module.exports = __webpack_public_path__ + "img/filter-black.b41e0f82.svg";